import QuizThumbnail from './QuizThumbnail';
export default QuizThumbnail;